import React, { useState } from "react";
import { useMsal } from "@azure/msal-react";
import { removeItem } from "../../../../utility/localStorageControl";

/**
 * Renders a sign-out button
 */
export const SignOutButton = () => {
  const { instance } = useMsal();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleLogout = (logoutType) => {
    if (logoutType === "popup") {
      removeItem("isMicrosoftLoggedIn");
      instance.logoutPopup({
        postLogoutRedirectUri: "/",
        mainWindowRedirectUri: "/",
      });
    }
    // else if (logoutType === "redirect") {
    //   removeItem("isMicrosoftLoggedIn");
    //   instance.logoutRedirect({
    //     postLogoutRedirectUri: "/",
    //   });
    // }
  };

  return (
    <div className="absolute bg-blue-500 mx-center px-4  w-3/4">
      {/* Trigger Button */}
      <button
        className="bg-blue-600 text-white px-2 py-2  rounded w-56  hover:bg-blue-700"
        onClick={toggleDropdown}
      >
        Sign Out
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <ul className="absolute left-0 mt-2 w-56 bg-white shadow-md rounded-md z-10">
          <li
            className="px-2 w-80 py-2 hover:bg-gray-100 cursor-pointer text-sm"
            onClick={() => handleLogout("popup")}
          >
            Sign out using Popup
          </li>
          {/*<li*/}
          {/*    className="px-2 w-80  py-2 hover:bg-gray-100 cursor-pointer text-sm"*/}
          {/*    onClick={() => handleLogout("redirect")}*/}
          {/*>*/}
          {/*  Sign out using Redirect*/}
          {/*</li>*/}
        </ul>
      )}
    </div>
  );
};
